import { createModule } from '../actions/utils';
import { SERVICE_ENDPOINT } from '../apis/constants';

const GetTallyConfigurations = createModule({
  base: 'GET_TALLY_CONFIGURATIONS', apiDetails: SERVICE_ENDPOINT.GET_TALLY_CONFIGURATIONS,
});

export { GetTallyConfigurations };
